// Stamped on <html> by vite.config.ts; absent under the dev server and in tests.
export const buildId = (): string =>
  document.documentElement.dataset.buildId ?? 'dev';
